import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Box } from '@mui/material';
import { SCUIContent } from '../../../../../atomic/organisms';
import { SCUIBreadCrumb, SCUIStepper } from '../../../../../atomic/molecules';
import { SCUILoadingLinear } from '../../../../../atomic/atoms';
import { AssigneeTab, ItemListTab } from './components';

import { handleStudioApiResponse } from '../../../../helper/studio_helper';
import { PlanningQuery } from '../../../../../services/studio/StudioQuery';

export const PlanningDetail = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [activeStep, setActiveStep] = useState<number>(1);
    const [employees, setEmployees] = useState<any[]>([]);
    const [employeeTitles, setEmployeeTitles] = useState<any[]>([]);
    const [studios, setStudios] = useState<any[]>([]);
    const [planningDetail, setPlanningDetail] = useState<any>(null);

    const { t } = useTranslation();
    const { planningId } = useParams<any>();

    const onStepChange = (clickedStep: number): void => {
        if (!planningDetail && clickedStep === 2) {
            return;
        }
        setActiveStep(clickedStep);
    };

    useEffect(() => {
        if (planningId) {
            handleStudioApiResponse(
                PlanningQuery.GetPlanById({
                    id: planningId,
                }),
                (res: any) => {
                    setPlanningDetail(res.data || []);
                },
                () => setIsLoading(false),
                t
            );
        }
    }, [planningId]);

    useEffect(() => {
        setIsLoading(true);

        handleStudioApiResponse(
            PlanningQuery.GetPlanningPageData(),
            (res: any) => {
                setEmployees(res.data?.employees || []);
                setEmployeeTitles(res.data?.employeeTitles || []);
                setStudios(res.data?.studios || []);
            },
            () => setIsLoading(false),
            t
        );
    }, []);

    useEffect(() => {
        if (activeStep === 0) {
            // tab component'lerini öldürüp tekrar render eder, yeni create için state'ler temizlenmiş olur
            setActiveStep(1);
            setPlanningDetail(null);
        }
    }, [activeStep]);

    return (
        <SCUIContent>
            <Box sx={{ padding: '16px' }}>
                <SCUIBreadCrumb
                    dontShowHome={true}
                    onlyTitle={t('studio.planning.header')}
                    components={[
                        {
                            title: t('studio.planning.list'),
                            link: '/studio/planning-list',
                        },
                    ]}
                />
                <SCUILoadingLinear display={isLoading} />
                <Box
                    sx={{
                        margin: '16px 0px',
                        '& .MuiStepLabel-root': {
                            cursor: 'pointer',
                        },
                    }}
                >
                    <SCUIStepper
                        stepList={[
                            { id: 1, name: t('studio.planning.assignment') },
                            { id: 2, name: t('studio.planning.itemListing') },
                        ]}
                        activeStep={activeStep}
                        onClick={onStepChange}
                    />
                </Box>
                {activeStep === 1 && (
                    <AssigneeTab
                        setIsLoading={setIsLoading}
                        planningDetail={planningDetail}
                        employees={employees}
                        employeeTitles={employeeTitles}
                        studios={studios}
                        setActiveStep={setActiveStep}
                        setPlanningDetail={setPlanningDetail}
                    />
                )}
                {activeStep === 2 && (
                    <ItemListTab
                        setIsLoading={setIsLoading}
                        planningDetail={planningDetail}
                        setActiveStep={setActiveStep}
                    />
                )}
            </Box>
        </SCUIContent>
    );
};
